import { ServiceOrderType } from "@/_constants/serviceOrder";

import Axios from "../../../_helpers/axiosHelper";
import {
  IOperatorAvailabilityBody,
  IResponseServicesDiagnosticTypes,
  IServiceOrdering,
} from "../interfaces";
import { IERPRequest } from "../reducers";

export const createServices = (
  serviceOrdering: IServiceOrdering
): Promise<Array<{ id: string; type: string }>> => {
  return Axios.post(`/agency/service`, serviceOrdering);
};
export const createERP = (erp: IERPRequest) => {
  const body: any = erp;
  return Axios.post(`/service/get-erp`, body);
};
export const getServicesAgendaTeam = (
  agencyId: string,
  startDate: string,
  endDate: string
) => {
  return Axios.get(`/agenda/agency/${agencyId}/services`, {
    params: { startDate, endDate },
  });
};

export const createCommandes = (services: IServiceOrdering) => {
  return Axios.post(`/service/`, services);
};

export const getServicesDiagnosticTypes = (
  serviceType: ServiceOrderType,
  dwellingId?: string
): Promise<IResponseServicesDiagnosticTypes> => {
  return Axios.get("/diagnostic-types", {
    params: {
      serviceType,
      dwellingId,
    },
  });
};

export const listOperator = (
  dwellingId: string,
  serviceType: string,
  isManagedByDwell: boolean = false
) => {
  return Axios.get(
    `/agency/operators/${dwellingId}/${String(isManagedByDwell)}/${serviceType}`
  );
};

export const listOperatorAvailability = (body: IOperatorAvailabilityBody) => {
  return Axios.post(`/agency/operators-availability`, body);
};

export const getServiceTypes = () => {
  return Axios.get("service/types/all");
};
